import { forwardRef, type Ref, type SVGProps } from "react";
const IconGroceryStoreOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M7 26a1 1 0 1 1-1 1 1 1 0 0 1 1-1m0-2a3 3 0 1 0 3 3 3 3 0 0 0-3-3m18 2a1 1 0 1 1-1 1 1 1 0 0 1 1-1m0-2a3 3 0 1 0 3 3 3 3 0 0 0-3-3m4-4H5.41l2-2h16.15a2 2 0 0 0 1.9-1.37l2.66-9A2 2 0 0 0 26.23 5H7a2 2 0 0 0-.51.07L3.71 2.29a1 1 0 0 0-1.42 1.42l2.78 2.78A2 2 0 0 0 5 7v9a2 2 0 0 0 .4 1.19l-3.11 3.1a1 1 0 0 0 0 1.42A1 1 0 0 0 3 22h26a1 1 0 0 0 1-1 1 1 0 0 0-1-1M7 7h19.23l-2.67 9H7Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconGroceryStoreOutlineSVG);
ForwardRef.displayName = "IconGroceryStoreOutline";
export { ForwardRef as IconGroceryStoreOutline };
